import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidPlaneDepartureAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M11.4 20.8c.4 0 .7-.2.9-.6l3.1-6.1H20c1.1 0 2-.9 2-2.1 0-1.2-.9-2.1-2.1-2.1h-4.6l-3.1-6.1c-.2-.3-.5-.6-.9-.6H10c-.6 0-1 .4-1 1 0 .1 0 .2.1.4l2 5.3H6c-.4 0-.8-.3-.9-.7l-.4-1.1c-.1-.4-.5-.7-.9-.7H3c-.6 0-1 .4-1 1v7.2c0 .6.4 1 1 1h.8c.4 0 .8-.3.9-.7l.4-1.1c.1-.4.5-.7.9-.7h5.1l-2 5.3c-.2.5.1 1.1.6 1.3.1 0 .2.1.4.1h1.3Z"/>
  </SvgIcon>
}

export default SolidPlaneDepartureAltIcon
